let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("5oXE9")).then(() => parcelRequire('gTjFa'));